import APIClient from '@/shared/http/clients/api'

const resourceName = 'gedChecklist'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)

const GedChecklistRepository = {
  GetAll
}

export default GedChecklistRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/gedchecklist.js